import React,{useEffect, useState, useCallback} from 'react';
import $ from 'jquery';
import {Table, Spinner} from 'react-bootstrap'
import fire from '../../fire'
// import Feedback from 'react-bootstrap/esm/Feedback';

const ParticipantCompiler = (props) =>{
    const [testCases, setTeastCases] = useState({})
    const [questionData, setQuestionData] = useState({})
    const [loader, setLoader] = useState(true)
    const [showSampleTable, setShowSampleTable] = useState(true)
    const [showTestCasesTable, setTestCasesTable] = useState(false)
    const [showSubmitLoader, setShowSubmitLoader] = useState(false)

      const [state,setState] = useState({
        lyrics:""
      })
      const textAreaRef = React.createRef
      const onChange = event => {
        setState({
          lyrics: event.target.value
        });
      };

      // const [input,setInput] = useState([])
      // const [expectedOutput, setExpectedOutput] = useState([])
      const [optionValue, setOptionValue] = useState("C++")


      const [time, setTime] = useState({
        seconds: 0,
        minutes: 0,
        hours: 0,
      });
    
      useEffect(() => {
        let isCancelled = false;
    
        const advanceTime = () => {
          setTimeout(() => {
            let nSeconds = time.seconds;
            let nMinutes = time.minutes;
            let nHours = time.hours;
    
            nSeconds++;
    
            if (nSeconds > 59) {
              nMinutes++;
              nSeconds = 0;
            }
            if (nMinutes > 59) {
              nHours++;
              nMinutes = 0;
            }
            if (nHours > 24) {
              nHours = 0;
            }
    
            !isCancelled && setTime({ seconds: nSeconds, minutes: nMinutes, hours: nHours });
          }, 1000);
        };
        advanceTime();
    
        return () => {
          //final time:
          
          isCancelled = true;
        };
      }, [time]);



      const loadData = useCallback(async () =>{
            setLoader(true)
            setShowSampleTable(true)
            setTestCasesTable(false)
            setQuestionData(props.data)
            setTeastCases(props.testCasesData)
            const tempArr = props.UCQI
            var user = await fire.auth().currentUser
            var sEmails =user.email.split("@") 
            var  use=sEmails[0].replace(/\./g,'"dot"')
            var domain=sEmails[1].replace(/\./g,'"dot"')
            var Email = ""
            Email = Email.concat(use,"@",domain) 
            Email = Email.toLowerCase()
            
            const response  = await fetch(`https://codezap-e156b.firebaseio.com/contests/${tempArr[1]}/participants/${Email}/${tempArr[0]}.json`)
            const resData = await response.json()
            if(resData){
              if(resData['submission']){
                setOptionValue(resData['lang'])
                setState({
                  lyrics: resData['submission']
                });
            }
            if(resData['time']){
              setTime(resData['time'])
            }
          }
            setLoader(false)
      },[props.UCQI, props.data, props.testCasesData])

      useEffect(() =>{
          loadData()
      },[loadData])



      const onKeyDown = event => {
        if (event.keyCode === 9) {
          event.preventDefault();
          const { selectionStart, selectionEnd } = event.target;
          setState(
            prevState => ({
              lyrics:
                prevState.lyrics.substring(0, selectionStart) +
                "\t" + // '\t' = tab, size can be change by CSS
                prevState.lyrics.substring(selectionEnd)
            }),
            () => {
              textAreaRef.current.selectionStart = textAreaRef.current.selectionEnd =
                selectionStart + 1;
            }
          );
        }
      };

      const API_KEY ="15f6434971msh928491e43f03395p19e452jsnaf224fda749e"; // Get yours for free at https://rapidapi.com/hermanzdosilovic/api/judge0
      var language_to_id = {
        "Bash": 46,
        "C": 50,
        "C#": 51,
        "C++": 54,
        "Java": 62,
        "Python": 71,
        "Ruby": 72
    };
    function encode(str) {
      return btoa(unescape(encodeURIComponent(str || "")));
  }

  function decode(bytes) {
      var escaped = escape(atob(bytes || ""));
      try {
          return decodeURIComponent(escaped);
      } catch {
          return unescape(escaped);
      }
  }

  function errorHandler(jqXHR, textStatus, errorThrown) {
      $("#output").val(`${JSON.stringify(jqXHR, null, 4)}`);
      $("#run").prop("disabled", false);
  }



  async function check(token, outputId) {
      $(outputId).val($(outputId).val() + "\nChecking submission status...");
      
      
      await $.ajax({
          url: `https://judge0-ce.p.rapidapi.com/submissions/${token}?base64_encoded=true`,
          type: "GET",
          headers: {
              "x-rapidapi-host": "judge0-ce.p.rapidapi.com",
            "x-rapidapi-key": API_KEY
          },
          success: async function (data, textStatus, jqXHR) {
              if ([1, 2].includes(data["status"]["id"])) {
                  $(outputId).val($(outputId).val() + "\nStatus: " + data["status"]["description"]);
                  setTimeout(async function() { await check(token, outputId) }, 1000);
              }
              else {
                  var output = [decode(data["compile_output"]), decode(data["stdout"])].join("\n").trim();

                  $(outputId).val(output);
                  var Ai = outputId.substring(1)
                  var aId = "#ex"+Ai
                  var aaId = "#a"+Ai
                  var wId = "#n"+Ai
                  var expectedOutput = $(aId).val()
                  
                  if(output === expectedOutput){
                      
                      
                      $(aaId).css("display",'block')
                      $(wId).css("display",'none')
                  }
                  else{
                    
                    $(aaId).css("display",'none')
                      $(wId).css("display",'block')
                  }
                  $("#run").prop("disabled", false);
              }
          },
          error: errorHandler
      });

      
      
      
  }



  const testCasesHandler = async() =>{
    setShowSampleTable(true)
    await setTestCasesTable(true)  
    
    for(var key in testCases){
      var id = "#" + key
      await run(testCases[key][0], id)
    }

    
    
    
              

    
    
  setTestCasesTable(true)
  }

 

  async function run(input, output) {


      $("#run").prop("disabled", true);
      $(output).val("Creating submission...");

      

      function makeRequest(){
        return $.ajax({
          url: "https://judge0-ce.p.rapidapi.com/submissions?base64_encoded=true",
          type: "POST",
          contentType: "application/json",
          headers: {
              "x-rapidapi-host": "judge0-ce.p.rapidapi.com",
            "x-rapidapi-key": API_KEY
          },
          data: JSON.stringify({
              "language_id": language_to_id[$("#lang").val()],
              "source_code": encode($("#source").val()),
              "stdin": encode(input),
              "redirect_stderr_to_stdout": true
          })
          // success: async function(data, textStatus, jqXHR) {
          //     $(output).val($(output).val() + "\nSubmission created.");
          //     setTimeout(async function() {await check(data["token"], output) }, 1000);
          // },
          // error: errorHandler
      });
      }

      await $.when(makeRequest()).then(async function successHandler(data){
        $(output).val($(output).val() + "\nSubmission created.");

        
        setTimeout(
          
          
          await function() { 
            
            check(data["token"], output) 
          
          }
          
          
          , 1000);
      }, function errorHandle(jqXHR, textStatus, errorThrown){
        $("#output").val(`${JSON.stringify(jqXHR, null, 4)}`);
        $("#run").prop("disabled", false);
      } )
      
      // const response = await $.ajax({
      //     url: "https://judge0.p.rapidapi.com/submissions?base64_encoded=true",
      //     type: "POST",
      //     contentType: "application/json",
      //     headers: {
      //         "x-rapidapi-host": "judge0.p.rapidapi.com",
      //       "x-rapidapi-key": API_KEY
      //     },
      //     data: JSON.stringify({
      //         "language_id": language_to_id[$("#lang").val()],
      //         "source_code": encode($("#source").val()),
      //         "stdin": encode(input),
      //         "redirect_stderr_to_stdout": true
      //     }),
      //     success: async function(data, textStatus, jqXHR) {
      //         $(output).val($(output).val() + "\nSubmission created.");
      //         setTimeout(async function() {await check(data["token"], output) }, 1000);
      //     },
      //     error: errorHandler
      // });

      

  }

  const runHandler = async() =>{
    setTestCasesTable(false)
    await run(questionData.sampeInput1, "#output")
    await run(questionData.sampeInput2, "#output1")
    setShowSampleTable(false)
  }

  const submitHandler = async() =>{
    setShowSubmitLoader(true)
    var score = 0
    for(var key in testCases){
      var aId = "#a"+key
      if($(aId).css("display") === "block"){
        score += 10
      }
    }

    const tempArr = props.UCQI
    var user = await fire.auth().currentUser
    var sEmails =user.email.split("@") 
    var  use=sEmails[0].replace(/\./g,'"dot"')
    var domain=sEmails[1].replace(/\./g,'"dot"')
    var Email = ""
    Email = Email.concat(use,"@",domain) 
    Email = Email.toLowerCase()
    var code = $("#source").val()
    var language = $("#lang").val()
    const response  = await fetch(`https://codezap-e156b.firebaseio.com/contests/${tempArr[1]}/participants/${Email}/${tempArr[0]}.json`,{
      method:'PATCH',
      headers:{
          'Content-Type':'application/json'
      },
      body:JSON.stringify({
        submission: code,
        score:score,
        lang:language,
        time:time
      })
  })

  setShowSubmitLoader(false)
  }
    return (
        <>
        { loader ? <p></p> :
        <>
            <h4>Select Language</h4>
                <select id="lang" style = {{width:"20%",height:"30%"}} className="form-control form-inline language" value = {optionValue} onChange = {(e) => setOptionValue(e.target.value)}>
                    <option>Bash</option>
                    <option>C#</option>
                    <option>C++</option>
                    <option>C</option>
                    <option>Java</option>
                    <option>Python</option>
                    <option>Ruby</option>
                </select>
                <br/>
        <textarea
        ref={textAreaRef}
        style = {{width:"70%",height:"280px"}}
        onKeyDown={onKeyDown}
        value = {state.lyrics}
        onChange={onChange}
        id = "source"
        autoCorrect = "off"
        autoCapitalize = "none"
        spellCheck = "false"
        tabIndex = "0"
        wrap = "off"
        />
        <br />

        <button className = "btn btn-primary" id="run" onClick={runHandler} style = {{width:"20%"}}>Run</button>
        <button className = "btn btn-info" id="Submit"  style = {{width:"20%",margin:"2%"}} onClick = {testCasesHandler}>Test</button>
        <br/>



        <br /><br/><br/>

        {showSampleTable ? <p></p> :
            <div>
        <Table striped bordered>
        <thead>
          <tr>
            <th>#</th>
            <th>Input</th>
            <th>Output</th>
            <th>Expected Output</th>

          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>
                    <textarea
                    className='autoExpand textarea1'
                    rows="5"

                    readOnly
                    style = {{
                        width:"100%",
                        backgroundColor:"#f2f2f2",

                        boxSizing: "border-box  !important",
                        border: "none !important",
                        borderRadius:" 3px !important",
                        resize: "none !important",
                        fontSize: "20px !important",
                        lineHeight: "24px !important",
                        overflow: "auto !important",
                        height: "auto !important",
                        padding: "8px !important",

                        }}
                    value = {questionData.sampeInput1}

                    />
            </td>
            <td>
                <textarea className='autoExpand textarea1'
                rows="5" readOnly = {true} id="output" style = {{
                    width:"100%",
                    backgroundColor:"#f2f2f2",

                    boxSizing: "border-box  !important",
                    border: "none !important",
                    borderRadius:" 3px !important",
                    resize: "none !important",
                    fontSize: "20px !important",
                    lineHeight: "24px !important",
                    overflow: "auto !important",
                    height: "auto !important",
                    padding: "8px !important",

                    }}></textarea>

            </td>
            <td>
                <textarea
                className='autoExpand textarea1'
                rows="5"

                readOnly
                style = {{
                    width:"100%",
                    backgroundColor:"#f2f2f2",

                    boxSizing: "border-box  !important",
                    border: "none !important",
                    borderRadius:" 3px !important",
                    resize: "none !important",
                    fontSize: "20px !important",
                    lineHeight: "24px !important",
                    overflow: "auto !important",
                    height: "auto !important",
                    padding: "8px !important",

                    }}
                value = {questionData.sampeOutput1}

                />
            </td>

          </tr>
          <tr>
            <td>2</td>
            <td>
                    <textarea
                    className='autoExpand textarea1'
                    rows="5"

                    readOnly
                    style = {{
                        width:"100%",


                        boxSizing: "border-box  !important",
                        border: "none !important",
                        borderRadius:" 3px !important",
                        resize: "none !important",
                        fontSize: "20px !important",
                        lineHeight: "24px !important",
                        overflow: "auto !important",
                        height: "auto !important",
                        padding: "8px !important",

                        }}
                    value = {questionData.sampeInput2}

                    />
            </td>
            <td>
                <textarea className='autoExpand textarea1'
                rows="5" readOnly = {true} id="output1" style = {{
                    width:"100%",
                    backgroundColor:"#fff",

                    boxSizing: "border-box  !important",
                    border: "none !important",
                    borderRadius:" 3px !important",
                    resize: "none !important",
                    fontSize: "20px !important",
                    lineHeight: "24px !important",
                    overflow: "auto !important",
                    height: "auto !important",
                    padding: "8px !important",

                    }}></textarea>
            </td>
            <td>
              <textarea
              className='autoExpand textarea1'
              rows="5"

              readOnly
              style = {{
                  width:"100%",
                  backgroundColor:"#fff",

                  boxSizing: "border-box  !important",
                  border: "none !important",
                  borderRadius:" 3px !important",
                  resize: "none !important",
                  fontSize: "20px !important",
                  lineHeight: "24px !important",
                  overflow: "auto !important",
                  height: "auto !important",
                  padding: "8px !important",

                  }}
              value = {questionData.sampeOutput2}

              />
            </td>
          </tr>

        </tbody>
      </Table>

        </div>}

            {showTestCasesTable ?
              <div>
                <Table striped bordered>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Input</th>
                      <th>Output</th>
                      <th>Expected Output</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                  {
                    Object.keys(testCases).map((item,i) =>
                      <tr key = {i}>
                        <td>{i}</td>
                        <td>

                          <i className="fa fa-lock" ></i>

                        </td>
                        <td>
                            <textarea className='autoExpand textarea1'
                              rows="5" readOnly = {true} id={item} style = {{
                                  width:"100%",
                                  backgroundColor:"#fff",

                                  boxSizing: "border-box  !important",
                                  border: "none !important",
                                  borderRadius:" 3px !important",
                                  resize: "none !important",
                                  fontSize: "20px !important",
                                  lineHeight: "24px !important",
                                  overflow: "auto !important",
                                  height: "auto !important",
                                  padding: "8px !important",

                                  }}></textarea>
                        </td>
                        <td>
                        <textarea
                        className='autoExpand textarea1'
                        rows="5"
                        id = {"ex"+item}
                        readOnly
                        style = {{
                            width:"100%",
                            backgroundColor:"#fff",

                            boxSizing: "border-box  !important",
                            border: "none !important",
                            borderRadius:" 3px !important",
                            resize: "none !important",
                            fontSize: "20px !important",
                            lineHeight: "24px !important",
                            overflow: "auto !important",
                            height: "auto !important",
                            padding: "8px !important",

                            }}
                        value = {testCases[item][1]}

                        />
                        </td>
                        <td>
                        <i className="fa fa-check-circle" id = {"a"+item} style = {{display:"none"}}></i>
                        <i className="fa fa-times-circle-o" id = {"n"+item} style = {{display:"none"}}></i>


                        </td>
                      </tr>
                    )
                  }
                  </tbody>
                </Table>
                <hr/>

                {
                  showSubmitLoader ?
                  <button className = "btn btn-success" id="Submit"  style = {{width:"15%",margin:"1% 1% 1% 85%", height:"37px"}} >
                
                      <Spinner animation="border" size = "sm"/>  
                
                </button>:
                <button className = "btn btn-success" id="Submit"  style = {{width:"15%",margin:"1% 1% 1% 85%", height:"37px"}} onClick = {submitHandler}>
                
                  <p>Submit</p> 
                
                </button>
        
        

                }
                
              </div>:
              <p></p>

            }
            </>
}
        </>
    )
}

export default ParticipantCompiler
